import React from 'react';

import * as Sentry from '@sentry/react';
import { decode } from 'jsonwebtoken';
import { shape, func } from 'prop-types';

import Paper from '@mui/material/Paper';

import Button from 'components/Common/Buttons/ButtonV2';
import { JWT } from 'constants/system';

import { getCookie } from 'utils/cookies';

import s from './ErrorBox.css';

// eslint-disable-next-line no-unused-vars
const ErrorBox = ({ error, componentStack, resetError }) => {
  Sentry.withScope(scope => {
    const token = getCookie(JWT);

    scope.setTag('version', VERSION);
    scope.setUser({
      type: 'guest',
      ...((token && decode(token)) || {}),
    });
    Sentry.captureException(error);
  });

  return (
    <div className={s.errorPage}>
      <Paper className={s.paper}>
        <div className={s.secondaryText}>
          Uh Oh! There was an Issue Processing Your Request.
        </div>
        <div className={s.primaryText}>We&apos;re Looking Into It!</div>
        <Button
          onClick={() => {
            window.location = '/';
          }}
          className={s.backToDashboard}
          color="primary"
          variant="outlined"
        >
          Return to Dashboard
        </Button>
      </Paper>
      <div className={s.errorId}>Error Code: error</div>
    </div>
  );
};

ErrorBox.propTypes = {
  error: shape({}).isRequired,
  componentStack: shape({}).isRequired,
  resetError: func.isRequired,
};

export default ErrorBox;
